<template lang="pug">
  .userFeatures
    van-nav-bar(:title="$t('users.userFeauturesTitle')")
      van-icon(name="left" slot="left" @click="back")

    .main
      .padding.text--center.text-gray3
        | {{ $t('users.affect') }}

      table
        tr
          th
            | {{ $t('users.table.unit.unit') }}
          th
            | {{ $t('users.table.basic') }}
          th
            | {{ $t('users.table.advanced') }}
        tr
          td
            | {{ $t('users.table.unit.setPoint') }}
          td
            .userCheck
          td
            .userCheck
        tr
          td
            | {{ $t('users.table.unit.setMode') }}
          td
            .userCheck
          td
            .userCheck
        tr
          td
            | {{ $t('users.table.unit.setFan') }}
          td
            .userCheck
          td
            .userCheck
        tr
          td
            | {{ $t('users.table.unit.turn') }}
          td
            .userCheck
          td
            .userCheck
        tr
          td
            | {{ $t('users.table.unit.viewSetting') }}
          td
            .userNoCheck
          td
            .userCheck

        tr
          th
            | {{ $t('users.table.schedules.schedules') }}
          th
            | {{ $t('users.table.basic') }}
          th
            | {{ $t('users.table.advanced') }}
        tr
          td
            | {{ $t('users.table.schedules.view') }}
          td
            .userNoCheck
          td
            .userCheck
        tr
          td
            | {{ $t('users.table.schedules.enable') }}
          td
            .userNoCheck
          td
            .userCheck
        tr
          td
            | {{ $t('users.table.schedules.create') }}
          td
            .userNoCheck
          td
            .userCheck

        tr
          th
            | {{ $t('users.table.groups.groups') }}
          th
            | {{ $t('users.table.basic') }}
          th
            | {{ $t('users.table.advanced') }}
        tr
          td
            | {{ $t('users.table.groups.addUnit') }}
          td
            .userNoCheck
          td
            .userCheck
        tr
          td
            | {{ $t('users.table.groups.updateUnit') }}
          td
            .userNoCheck
          td
            .userCheck
        tr
          td
            | {{ $t('users.table.groups.removeUnit') }}
          td
            .userNoCheck
          td
            .userCheck
        tr
          td
            | {{ $t('users.table.groups.addGroup') }}
          td
            .userNoCheck
          td
            .userCheck
        tr
          td
            | {{ $t('users.table.groups.updateGroup') }}
          td
            .userNoCheck
          td
            .userCheck
        tr
          td
            | {{ $t('users.table.groups.removeGroup') }}
          td
            .userNoCheck
          td
            .userCheck

        tr
          th
            | {{ $t('users.table.users.users') }}
          th
            | {{ $t('users.table.basic') }}
          th
            | {{ $t('users.table.advanced') }}
        tr
          td
            | {{ $t('users.table.users.view') }}
          td
            .userNoCheck
          td
            .userCheck
        tr
          td
            | {{ $t('users.table.users.add') }}
          td
            .userNoCheck
          td
            .userCheck
        tr
          td
            | {{ $t('users.table.users.update') }}
          td
            .userNoCheck
          td
            .userCheck
        tr
          td
            | {{ $t('users.table.users.remove') }}
          td
            .userNoCheck
          td
            .userCheck
</template>

<script>
export default {
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
